<template>
  <VaModal class="session-recovery-modal" :model-value="required" :hide-default-actions="true" no-dismiss
    :overlay-opacity="1" size="small" max-width="400px" :mobile-fullscreen="false">
    <div class="session-recovery">
    <h2 class="session-recovery-title">Войдите повторно</h2>
    <p v-if="hasOpenForm" class="session-recovery-description">Введённые данные остаются в открытой форме.</p>
    <p v-else class="session-recovery-description">Сессия завершилась. Подтвердите вход, чтобы продолжить работу.</p>
    <div class="session-recovery-account">
      <p class="session-recovery-caption">Войдите под этой учётной записью</p>
      <p class="session-recovery-name"><strong>{{ expectedFullName }}</strong></p>
      <p class="session-recovery-login">Логин: <strong>{{ expectedLogin }}</strong></p>
    </div>
    <form class="session-recovery-form" @submit.prevent="submit">
      <VaInput v-model="username" label="Имя пользователя" autocomplete="username" :disabled="busy" />
      <VaInput v-model="password" label="Пароль" type="password" autocomplete="current-password" :disabled="busy" />
      <p v-if="error" class="session-recovery-error" role="alert">{{ error }}</p>
      <VaButton type="submit" :loading="busy" :disabled="busy || !username || !password">Продолжить работу</VaButton>
    </form>
    <VaAlert class="session-recovery-hint" color="primary" border="left">
      <template v-if="pendingCount">После входа прерванное действие продолжится автоматически.</template>
      <template v-else-if="hasOpenForm">После входа сможете продолжить заполнение. Не обновляйте и не закрывайте страницу.</template>
      <template v-else>После входа сможете продолжить работу.</template>
    </VaAlert>
    </div>
  </VaModal>
</template>

<script>
import { reauthenticate } from '../services/setupInterceptors'
import { hasVisibleEditingForm } from '../services/editingForms'
export default {
  data: () => ({ username: '', password: '', error: '', busy: false }),
  computed: {
    required() { return this.$store.state.auth.reauthRequired },
    pendingCount() { return this.$store.state.auth.recoveryPendingCount || 0 },
    expectedLogin() {
      return this.$store.state.app.account.profile?.username || 'Логин не определён'
    },
    expectedFullName() {
      return this.$store.state.app.account.profile?.full_name || 'ФИО не указано'
    },
    hasOpenForm() {
      return this.required && hasVisibleEditingForm()
    },
  },
  watch: {
    required: {
      immediate: true,
      handler(value) {
        this.password = ''
        this.error = ''
        if (value) this.username = this.$store.state.app.account.profile?.username || ''
      },
    },
  },
  methods: {
    async submit() {
      if (this.busy) return
      this.busy = true
      this.error = ''
      try {
        await reauthenticate({ username: this.username, password: this.password })
      } catch (error) {
        this.error = error.code === 'SESSION_USER_MISMATCH'
          ? `Для продолжения войдите под учётной записью ${this.expectedLogin} — ${this.expectedFullName}.`
          : error.response?.status === 401
            ? 'Неверное имя пользователя или пароль.'
            : 'Не удалось выполнить вход. Проверьте соединение и повторите попытку.'
      } finally {
        this.password = ''
        this.busy = false
      }
    },
  },
}
</script>

<style scoped>
.session-recovery {
  width: 320px;
  max-width: 100%;
  margin: 0 auto;
}
.session-recovery-title {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
}
.session-recovery-description {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #596273;
}
.session-recovery-account {
  margin: 20px 0;
  padding: 12px 14px;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  background: #f7f8fb;
  overflow-wrap: anywhere;
}
.session-recovery-caption {
  margin: 0 0 6px;
  color: #596273;
  font-size: 12px;
  line-height: 1.4;
}
.session-recovery-name {
  margin: 0 0 4px;
  font-size: 16px;
  line-height: 1.4;
}
.session-recovery-login {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #596273;
}
.session-recovery-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
  margin: 0 0 20px;
  width: 100%;
  max-width: 100%;
}
.session-recovery-form :deep(.va-button) {
  justify-self: stretch;
  width: 100%;
  max-width: none;
}
.session-recovery-error {
  margin: 0;
  color: var(--va-danger);
  font-size: 13px;
  line-height: 1.5;
}
.session-recovery-hint {
  --va-alert-box-shadow: none;
  margin: 0;
  box-shadow: none;
  font-size: 13px;
  line-height: 1.5;
}
</style>

<style>
/* The modal is teleported outside the component; override only this dialog. */
.va-modal.session-recovery-modal .va-modal__dialog {
  min-width: 0;
  width: min(400px, calc(100vw - 32px));
}
</style>
